// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import Modal from '../../_common/Modal';
import ItemList from '../ItemList';
import ForceLocation from '../ForceLocation';
import { HamQuest } from '../../../App';

const Bundles = ({ ...props }) => {
    const [bundles, setBundles] = useState([]);

    useEffect(() => {
        HamQuest.get(QuestRoute.products.bundles)
            .then((res) => {
                setBundles(res)
            })
            .catch(ex => {
                Modal.Show({
                    type: 'error',
                    title: 'Unable to get Bundles',
                    body: 'Sorry, something went wrong. Please try again.'
                })
            })
    }, [])

    return (
        <ForceLocation route={'bundles'}>
            <ItemList items={bundles} />
        </ForceLocation>
    );
}

export default Bundles;